import React from 'react';
import { APITypes } from '../../../../primary-record-types';
import getName from '../../../../utils/getName';
import Stack, { contentStackSpacing } from '../../../v2BaseComponents/Stack';
import { getIntl } from '../../../../utils/intl';
import RichTable from '../../../v2BaseComponents/RichTable';
import { useRichTableState } from '../../../v2BaseComponents/RichTable/useRichTableState';
import { TableConfig } from '../../../v2BaseComponents/RichTable/types';
import { clientRecordStatus } from '../../../../utils/sharedMessages';
import getDateString from '../../../../utils/getDateString';

const intl = getIntl('client-profile-history', {
    header: "{name}'s Client History",
    pointOfContact: 'Point of Contact',
    status: 'Status',
    created: 'Created',
});

export type ClientProfileHistoryOwnProps = {
    history: APITypes.organizationService.GetOrganizationClientRecordsForMedicalProfileResponse['items'];
    noTablePaper?: boolean;
};

export type ClientProfileHistoryProps = ClientProfileHistoryOwnProps;

const ClientProfileHistory: React.FC<ClientProfileHistoryProps> = (props) => {
    const [tableState, setTableState] = useRichTableState();
    const sorted = props.history.sort(
        (a, b) => new Date(b.createdDateTime).getTime() - new Date(a.createdDateTime).getTime(),
    );
    const clientProfilesTableConfig: TableConfig<APITypes.organizationService.OrganizationClientRecordDetails> = {
        columns: [
            {
                label: intl('pointOfContact'),
                columnKey: 'pointOfContact',
                render: (item) => (item?.clientOrganizerDetails ? getName(item.clientOrganizerDetails) : null),
            },
            {
                label: intl('status'),
                columnKey: 'status',
                render: (item) => clientRecordStatus(item.status),
                hideOnMobile: true,
            },
            {
                label: intl('created'),
                columnKey: 'created',
                render: (item) => getDateString(item.createdDateTime, 'date'),
                hideOnMobile: true,
            },
        ],
        getRowKey: (item) => item.organizationClientRecordId,
    };

    return (
        <Stack vertical fullWidth fullHeight space={contentStackSpacing}>
            <RichTable
                config={clientProfilesTableConfig}
                state={tableState}
                onStateChange={setTableState}
                data={sorted}
                minWidth={'100%'}
                style={{ height: '100%' }}
                noPaper={props.noTablePaper}
                noPaperPadding
            />
        </Stack>
    );
};

export default React.memo(ClientProfileHistory);
